module.exports = __webpack_public_path__ + "img/bg.0ef89f3e.svg";